import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import TimelineCompleteIcon from "@/assets/icons/timeline-complete.svg"
import TimelineInProgressIcon from "@/assets/icons/timeline-inprogress.svg"
import TimelineTodoIcon from "@/assets/icons/timeline-todo.svg"
import TimelineWaitingIcon from "@/assets/icons/timeline-waiting.svg"
import { type FC, type ReactNode } from "react"
import { type SvgProps } from "react-native-svg"
import { Body, H4 } from "@/components/standard/BFText"
import { View } from "react-native"
import { BFColors } from "@/constants/Colors"

const ICONS: Record<TimelineStatus, FC<SvgProps>> = {
  complete: TimelineCompleteIcon,
  inprogress: TimelineInProgressIcon,
  todo: TimelineTodoIcon,
  waiting: TimelineWaitingIcon,
}

export interface VerticalTimelineProps {
  items: TimelineEntry[]
  className?: string
}

export type TimelineStatus = "complete" | "inprogress" | "todo" | "waiting"

export interface TimelineEntry {
  title: string
  description?: string | ReactNode
  status: TimelineStatus
}

const VerticalTimelineItem = ({
  title,
  description,
  status,
  last,
}: TimelineEntry & { last: boolean }) => {
  const Icon = ICONS[status]

  return (
    <Horizontal
      className={`relative ${status === "todo" && "opacity-50"} min-h-10`}
    >
      <View
        className={"w-5"}
        style={{
          borderColor: last ? "transparent" : BFColors.lightGrey,
          borderLeftWidth: 1,
          // borderStyle: "dotted",
          marginTop: 6,
        }}
      />
      <Vertical className={`${status === "todo" && "opacity-50"} pb-6 flex-1`}>
        <H4>{title}</H4>
        {description && <Body>{description}</Body>}
      </Vertical>
      <Icon
        style={{
          position: "absolute",
          left: -6,
          top: 4,
        }}
      />
    </Horizontal>
  )
}

export const VerticalTimeline = ({
  items,
  className,
}: VerticalTimelineProps) => {
  return (
    <Vertical className={`flex-1 ${className}`}>
      {items.map((item, index) => (
        <VerticalTimelineItem
          key={index}
          {...item}
          last={index === items.length - 1}
        />
      ))}
    </Vertical>
  )
}
